import { render, staticRenderFns } from "./CtaArrullos.vue?vue&type=template&id=41247250"
import script from "./CtaArrullos.vue?vue&type=script&lang=js"
export * from "./CtaArrullos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports